<template>
  <div :class="isMobile ? `${classVariableName}-mob-filter-container` : ''">
    <div :class="isMobile ? `${classVariableName}-mob-filter` : `${classVariableName}-filter`">
      <div v-if="isMobile" :class="`${classVariableName}-mob-filter-title`">
        <div :class="`${classVariableName}-filter-text`">
          Reviews
        </div>
        <div
          @click="resetFilters"
          :class="`${classVariableName}-filter-reset`"
        >
          Reset filters
        </div>
      </div>
      <div v-if="!isMobile" :class="`${classVariableName}-filter-text`">
        Filter By
      </div>
      <div :class="isMobile ? `${classVariableName}-mob-filter-list` : `${classVariableName}-filter-list`">
        <div
          v-if="!isEmpty(colorVariants)"
          :class="`${classVariableName}-filter-select ${
            isEmpty(colorVariants)
              ? `disabled`
              : colorDropdown ? `openColorDropdown` : ``
          }`"
        >
          <div
            @click="() => {
              if(colorDropdown) {this.tempColorFilters = [...this.filter.color.items];}
              colorDropdown = !colorDropdown;
            }"
            id="color-dropdown-filter"
            :class="`${classVariableName}-filter-input ${!isEmpty(filter.color.items) ? `selected` : ``}`"
          >
            <div
              :class="`${classVariableName}-filter-placeholder`"
              v-if="isEmpty(filter.color.items)"
            >
              Shades
            </div>
            <div :class="`${classVariableName}-filter-placeholder`" v-else>
              <img
                width="24px"
                height="24px"
                :src="getVariant(filter.color.items[0]).medias[getVariant(filter.color.items[0]).medias.length-1].url"
              />
              <div :class="`${classVariableName}-filter-placeholder-name`"> {{ getVariant(filter.color.items[0]).color_name || getVariant(filter.color.items[0]).name }} </div>
              <div v-if="filter.color.items.length > 1" style="min-width: fit-content;">
                +{{ filter.color.items.length - 1 }}
              </div>
            </div>
            <Arrow
              :class="`${classVariableName}-auto-margin-left`"
              :direction="colorDropdown ? 'top' : 'bottom'"
            />
          </div>
        </div>
        <div
          :class="`${classVariableName}-filter-select ${ratingDropdown ? `openRatingDropdown` : ``}`"
        >
          <div
            @click="() => {
              if (ratingDropdown) {this.tempRatingFilters = [...this.filter.rating.items];}
              ratingDropdown = !ratingDropdown;
            }"
            id="rating-dropdown-filter"
            :class="`${classVariableName}-filter-input ${
              !isEmpty(filter.rating.items) ? `selected` : ``
            }`"
          >
            <div
              v-if="isEmpty(filter.rating.items)"
              :class="`${classVariableName}-filter-placeholder`"
            >
              Ratings
            </div>
            <div v-else :class="`${classVariableName}-filter-placeholder`">
              {{ filter.rating.items[0] }} <Star kind="filled" />
              <div v-if="filter.rating.items.length > 1" style="min-width: fit-content;">
                + {{ filter.rating.items.length - 1 }}
              </div>
            </div>
            <Arrow
              :class="`${classVariableName}-auto-margin-left`"
              :direction="ratingDropdown ? 'top' : 'bottom'"
            />
          </div>
        </div>
        <div
          :class="`${classVariableName}-filter-select ${originDropdown ? `openOriginDropdown` : ``}`"
          v-if="!isEmpty(originDetails)"
        >
          <div
            @click="() => {
              if (originDropdown) {this.tempOriginFilters = [...this.filter.origin.items];}
              originDropdown = !originDropdown;
            }"
            id="origin-dropdown-filter"
            :class="`${classVariableName}-filter-input ${
              !isEmpty(filter.origin.items) ? `selected` : ``
            }`"
          >
            <div
              :class="`${classVariableName}-filter-placeholder`"
            >
              Reviews By
            </div>

            <Arrow
              :class="`${classVariableName}-auto-margin-left`"
              :direction="originDropdown ? 'top' : 'bottom'"
            />
          </div>
        </div>
        <div
          @click="() => setFilter('image')"
          :class="`${classVariableName}-filter-input ${
            filter.image.selected ? `selected` : ``
          }`"
        >
          Reviews with image
        </div>
        <!-- <div
          @click="() => setFilter('upvote')"
          :class="`${classVariableName}-filter-input ${
            filter.upvote.selected ? `selected` : ``
          }`"
        >
          Most Helpful
        </div> -->
      </div>
      <div
        v-if="!isMobile"
        @click="resetFilters"
        :class="`${classVariableName}-filter-reset`"
      >
        Reset filters
      </div>
    </div>
    
    <div
      :class="`${classVariableName}-color-dropdown-container`"
      v-if="colorDropdown"
      id="color-dropdown-content"
    >
      <div :class="`${classVariableName}-color-dropdown-content`">
        <div
          :class="`${
            isEmpty(variantStats) ||
            isEmpty(variantStats[`${variant.uid}`]) ||
            !variantStats[`${variant.uid}`].reviewsCount ||
            variantStats[`${variant.uid}`].reviewsCount === 0
              ? `${classVariableName}-color-dropdown-item-disabled`
              : `${classVariableName}-color-dropdown-item`
          }`"
          @click="selectColor(variant.uid)"
          v-for="variant in colorVariants"
          :key="variant.uid"
        >
          <img
            :class="`${classVariableName}-color-dropdown-img ${
              ifSelected(tempColorFilters,variant.uid) ? 'selected' : ''
            }`"
            :src="variant.medias[variant.medias.length-1].url"
          />
          <div>
            <div :class="`${classVariableName}-color-dropdown-hex`" v-if="variant['color-hex']">
              {{ variant['color-hex'] }}
            </div>
            <div :class="`${classVariableName}-color-dropdown-name`">
              {{ variant.color_name || variant.name }}
            </div>
          </div>
        </div>
      </div>
      <div :class="`${classVariableName}-filter-action`">
        <button
          :class="`${classVariableName}-panel-footer-button-secondary`"
          @click="() => {
            tempColorFilters = [];
            filter.color.items = [...tempColorFilters];
            setFilter('color');
            colorDropdown = false;
          }"
        >
          Clear All
        </button>
        <button
          :class="`${classVariableName}-panel-footer-button-primary`"
          @click="() => {
            filter.color.items = [...tempColorFilters];
            setFilter('color');
            colorDropdown = false;
          }"
        >
          Apply
        </button>
      </div>
    </div>

    <div
      :class="`${classVariableName}-rating-dropdown-container`"
      v-if="ratingDropdown"
      id="rating-dropdown-content"
    >
      <div :class="`${classVariableName}-rating-dropdown-content`">
        <div
          :class="`${
            isEmpty(reviewStats) ||
            isEmpty(reviewStats[`${key.id}`]) ||
            reviewStats[`${key.id}`] === 0 || getRatingCountForVariantFilters(key.id) === 0
              ? `${classVariableName}-rating-dropdown-item-disabled`
              : `${classVariableName}-rating-dropdown-item`
          }`"
          @click="() => {
            if (
              isEmpty(reviewStats) ||
              isEmpty(reviewStats[`${key.id}`]) ||
              reviewStats[`${key.id}`] === 0 || getRatingCountForVariantFilters(key.id) === 0
            )
              return;
            if (tempRatingFilters.includes(key.id)) {
              let filtered = tempRatingFilters.filter(
                (pr) => key.id !== pr
              );
              tempRatingFilters = [...filtered];
            } else {
              tempRatingFilters.push(key.id);
            }
          }"
          v-for="key in ratingKeys"
          :key="key.id"
        >
          <div :class="`${classVariableName}-rating-dropdown-heading`">
            {{ key.id }}
          </div>
          <Star kind="filled" />
          <div :class="`${classVariableName}-rating-dropdown-count`">
            ({{
              getRatingCountForVariantFilters(key.id)
            }})
          </div>
          <div
            :class="`${classVariableName}-rating-checkbox-div`"
            :aria-disabled="
              isEmpty(reviewStats) ||
              isEmpty(reviewStats[`${key.id}`]) ||
              reviewStats[`${key.id}`] === 0 || getRatingCountForVariantFilters(key.id) === 0 ? 'true' : 'false'
            "
          >
            <svg v-if="tempRatingFilters.includes(key.id)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_4371_67818)">
                <rect width="24" height="24" fill="white"/>
                <rect x="3" y="3" width="18" height="18" rx="6" fill="#211A1E"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.967 8.49377C17.2013 8.7281 17.2013 9.10799 16.9669 9.3423L11.0849 15.2239C10.6944 15.6144 10.0613 15.6144 9.67074 15.2239L7.03219 12.5855C6.79787 12.3512 6.79786 11.9713 7.03217 11.737C7.26648 11.5027 7.64638 11.5027 7.8807 11.737L10.3778 14.234L16.1184 8.49375C16.3528 8.25944 16.7327 8.25945 16.967 8.49377Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_4371_67818">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_590_33363)">
                <rect width="24" height="24" fill="white"/>
                <rect x="3.6" y="3.6" width="16.8" height="16.8" rx="5.4" stroke="#211A1E" stroke-width="1.2"/>
              </g>
              <defs>
                <clipPath id="clip0_590_33363">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div :class="`${classVariableName}-filter-action`">
        <button
          :class="`${classVariableName}-panel-footer-button-secondary`"
          @click="() => {
            tempRatingFilters = [];
            filter.rating.items = [...tempRatingFilters];
            setFilter('rating');
            ratingDropdown = false;
          }"
        >
          Clear All
        </button>
        <button
          :class="`${classVariableName}-panel-footer-button-primary`"
          @click="() => {
            filter.rating.items = [...tempRatingFilters];
            setFilter('rating');
            ratingDropdown = false;
          }"
        >
          Apply
        </button>
      </div>
    </div>
    <div
      :class="`${classVariableName}-origin-dropdown-container`"
      v-if="originDropdown"
      id="origin-dropdown-content"
    >
      <div :class="`${classVariableName}-origin-dropdown-content`">
        <div
          :class="`${classVariableName}-origin-dropdown-item`"
          @click="selectOrigin(origin)"
          v-for="(origin,index) in originDetails"
          :key="index"
        >
          <div :class="`${classVariableName}-origin-dropdown-heading`">
            {{ origin }}
          </div>
          <div
            :class="`${classVariableName}-origin-checkbox-div`"
          >
            <svg v-if="tempOriginFilters.includes(origin)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_4371_67818)">
                <rect width="24" height="24" fill="white"/>
                <rect x="3" y="3" width="18" height="18" rx="6" fill="#211A1E"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.967 8.49377C17.2013 8.7281 17.2013 9.10799 16.9669 9.3423L11.0849 15.2239C10.6944 15.6144 10.0613 15.6144 9.67074 15.2239L7.03219 12.5855C6.79787 12.3512 6.79786 11.9713 7.03217 11.737C7.26648 11.5027 7.64638 11.5027 7.8807 11.737L10.3778 14.234L16.1184 8.49375C16.3528 8.25944 16.7327 8.25945 16.967 8.49377Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_4371_67818">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_590_33363)">
                <rect width="24" height="24" fill="white"/>
                <rect x="3.6" y="3.6" width="16.8" height="16.8" rx="5.4" stroke="#211A1E" stroke-width="1.2"/>
              </g>
              <defs>
                <clipPath id="clip0_590_33363">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div :class="`${classVariableName}-filter-action`">
        <button
          :class="`${classVariableName}-panel-footer-button-secondary`"
          @click="() => {
            tempOriginFilters = [];
            filter.origin.items = [...tempOriginFilters];
            setFilter('origin');
            originDropdown = false;
          }"
        >
          Clear All
        </button>
        <button
          :class="`${classVariableName}-panel-footer-button-primary`"
          @click="() => {
            filter.origin.items = [...tempOriginFilters];
            setFilter('origin');
            originDropdown = false;
          }"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { isEmpty, classVariableName, RATING_KEYS } from "../utils";
import Star from "./common/Star.vue";
import Arrow from "./common/Arrow.vue";
export default defineComponent({
  setup() {},
  components: {
    Star,
    Arrow,
  },
  data() {
    return {
      filter: {
        color: {
          items: [],
        },
        rating: {
          items: [],
        },
        origin: {
          items: [],
        },
        image: {
          selected: false,
        },
        upvote: {
          selected: false,
        },
      },
      colorDropdown: false,
      ratingDropdown: false,
      originDropdown: false,
      tempColorFilters: [],
      tempRatingFilters: [],
      tempOriginFilters: [],
      colorVariants: null,
      ratingKeys: RATING_KEYS,
      classVariableName: classVariableName,
    };
  },
  props: {
    reviewStats: Object,
    variantStats: Object,
    originDetails: Object,
    isMobile: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    window.addEventListener("click", this.closeDropdownOutsideClick);
    window.FPI.state.product.variants.subscribe(this.getVariants.bind(this));
  },
  destroy() {
    window.removeEventListener("click", this.closeDropdownOutsideClick);
    window.FPI.state.product.variants.unsubscribe(this.getVariants.bind(this));
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    },
    async closeDropdownOutsideClick(event) {
      if (
        this.ratingDropdown &&
        !document.getElementById('rating-dropdown-content').contains(event.target) &&
        !document.getElementById('rating-dropdown-filter').contains(event.target)
      ) {
        this.ratingDropdown = false;
        this.tempRatingFilters = [...this.filter.rating.items];
      }
      if (
        this.originDropdown &&
        !document.getElementById('origin-dropdown-content').contains(event.target) &&
        !document.getElementById('origin-dropdown-filter').contains(event.target)
      ) {
        this.originDropdown = false;
        this.tempOriginFilters = [...this.filter.origin.items];
      }
      if (
        this.colorDropdown &&
        !document.getElementById('color-dropdown-content').contains(event.target) &&
        !document.getElementById('color-dropdown-filter').contains(event.target)
      ) {
        this.colorDropdown = false;
        this.tempColorFilters = [...this.filter.color.items];
      }
    },
    ifSelected(arr,checkVal) {
      let val = arr.filter((pr) => pr === checkVal);
      return !isEmpty(val);
    },
    async getVariants(data) {
      let variants = data.variants;
      if (!isEmpty(variants)) {
        let colorVariants = variants.filter((types) => types.key === "color");
        if (!isEmpty(colorVariants)) {
          this.colorVariants = colorVariants[0].items;
        }
      }
    },
    async setFilter(event) {
      this.filter[`${event}`].selected = !this.filter[`${event}`].selected;
      this.$emit("updateFilter", this.filter);
    },
    async resetFilters() {
      this.filter = {
        color: {
          items: [],
        },
        rating: {
          items: [],
        },
        origin: {
          items: [],
        },
        image: {
          selected: false,
        },
        upvote: {
          selected: false,
        },
      };
      this.tempColorFilters = [];
      this.tempRatingFilters = [];
      this.tempOriginFilters = [];
      this.$emit("updateFilter", this.filter);
    },

    selectColor(itemId) {
      if (this.ifSelected(this.tempColorFilters,itemId)) {
        let filtered = this.tempColorFilters.filter((pr) => pr !== itemId);
        this.tempColorFilters = [...filtered];
      } else {
        this.tempColorFilters = [...this.tempColorFilters, itemId];
      }
    },

    selectOrigin(originName) {
      if (this.ifSelected(this.tempOriginFilters,originName)) {
        let filtered = this.tempOriginFilters.filter((pr) => pr !== originName);
        this.tempOriginFilters = [...filtered];
      } else {
        this.tempOriginFilters = [...this.tempOriginFilters, originName];
      }
    },

    getVariant(itemId) {
      return this.colorVariants.filter((pr) => pr.uid === itemId)[0];
    },

    getRatingCountForVariantFilters(ratingKey) {      
      if(!isEmpty(this.filter.color.items)) {
        return this.filter.color.items.reduce((sum, variant) => {
          const variantStat = this.variantStats[variant.toString()]
          const variantReviewsDetails = variantStat ? variantStat.reviewsCountDetails || {} : {};
          return sum + (variantReviewsDetails[ratingKey] || 0);
        }, 0);
      } else {
        return !isEmpty(this.reviewStats) && !isEmpty(this.reviewStats[ratingKey])
                ? this.reviewStats[ratingKey]
                : 0
      }
    }
  },
});
</script>

<style lang="scss" scoped>
@import "../assets/Filter.scss";
</style>
